import { gql, useMutation } from '@apollo/client';

import { GET_COMPANIES_WITH_JOBS } from './get-companies-with-jobs.hook';

export const DELETE_JOB_BY_ID = gql`
  mutation deleteJobById($jobId: ObjectId!) {
    deleteJobById(jobId: $jobId)
  }
`;

export const useDeleteJobById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteJobById] = useMutation(DELETE_JOB_BY_ID, {
    refetchQueries: [GET_COMPANIES_WITH_JOBS],
    onCompleted: onSuccess,
  });

  return deleteJobById;
};
